<script setup lang="ts">
import { getImageStubSrc } from '~/utils/image-utils'
// https://image.nuxt.com/usage/nuxt-img

defineProps<{
  src: string
  sizes: string
  width: number
  height: number
  preset: 'card-list-logo'
}>()
</script>

<template>
  <NuxtImg
    :src="src || getImageStubSrc()"
    class="logo__image"
    alt=""
    :placeholder="[width, height]"
    :width="width"
    :height="height"
    :sizes="sizes"
    :preset="preset"
    loading="lazy"
  />
</template>

<style lang="scss" scoped>
.logo__image {
  object-fit: cover;
  background: var(--app-color-sendcloud-white);
  object-position: center;
}

</style>
